import { Injectable } from '@angular/core';
import { Guest, ValidationResult } from '..';
import { GuestRole } from '../models/guest-role.model';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor() { }

  public validateGuest(guest: Guest): ValidationResult {
    let result = new ValidationResult();

    if (guest.firstName && guest.lastName && guest.birthdate &&
      this.validateEmail(guest.email) && guest.phone && guest.postalCode && guest.gender) {
      result.isValid = true;
    }
    if (!guest.firstName) {
      result.reasons.push('Invalid first name');
    }
    if (!guest.lastName) {
      result.reasons.push('Invalid last name');
    }
    if (!guest.birthdate) {
      result.reasons.push('Invalid date of birth');
    }
    if (!this.validateEmail(guest.email)) {
      result.reasons.push('Invalid email');
    }
    if (!guest.phone) {
      result.reasons.push('Invalid phone number');
    }
    if (!guest.postalCode) {
      result.reasons.push('Invalid postal code');
    }
    if (!guest.gender) {
      result.reasons.push('Invalid gender');
    }

    return result;
  }

  public validateGuestRole(guestRole: GuestRole): boolean {
    let valid = false;
    if (guestRole.organization &&
      guestRole.roleId &&
      guestRole.startDate &&
      guestRole.endDate) {
      valid = true;
    }
    return valid;
  }

  public validateEmail(email: string): boolean {
    const regex = RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$');
    const valid = regex.test(email);
    return valid;
  }
}
